import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import MainNavigation from '../../components/ui/MainNavigation';
import HeroSection from './components/HeroSection';
import ProblemRecognitionSection from './components/ProblemRecognitionSection';
import SolutionOverviewSection from './components/SolutionOverviewSection';
import CategoryGrid from './components/CategoryGrid';
import IndependentKnowledgeSection from './components/IndependentKnowledgeSection';
import TestimonialsSection from './components/TestimonialsSection';
import ProviderSpotlight from './components/ProviderSpotlight';
import CustomerConversionBlock from './components/CustomerConversionBlock';
import ProviderConversionBlock from './components/ProviderConversionBlock';
import FooterSection from './components/FooterSection';

const Homepage = () => {
  const { user, userProfile, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user && userProfile) {
      // Redirect based on user type
      if (userProfile?.user_type === 'provider') {
        navigate('/provider-dashboard');
      }
      // Customer stays on homepage
    }
  }, [user, userProfile, loading, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Laden...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <MainNavigation />

      {/* Main Content with proper spacing for fixed navigation */}
      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
      {/* 1. Hero Section - Dual CTAs + Trust Signals */}
      <HeroSection />

      {/* 2. Problem Recognition */}
      <ProblemRecognitionSection />

      {/* 3. Solution Overview - 4 Steps */}
      <SolutionOverviewSection />

      {/* 4. Popular Solutions Grid */}
      <div id="solutions">
        <CategoryGrid />
      </div>

      {/* 5. Independent Knowledge */}
      <div id="knowledge">
        <IndependentKnowledgeSection />
      </div>

      {/* 6. Reviews & Social Proof */}
      <div id="reviews">
        <TestimonialsSection />
      </div>

      {/* 7. Selected Providers */}
      <div id="providers">
        <ProviderSpotlight />
      </div>

      {/* 8. Customer Conversion Block (B2C) */}
      <CustomerConversionBlock />

      {/* 9. Provider Conversion Block (B2B) */}
      <ProviderConversionBlock />

      {/* 10. Footer */}
      <FooterSection />
      </main>
    </div>
  );
};

export default Homepage;